// PRINT = THE SAME PAPER AS EXPORT (owner, 2026-10-13: "yes add the print
// button"). Ctrl+P on the tab printed the screen table, which has no print
// layout; Print now hands the browser the very PDF Export downloads, in a
// hidden frame, and opens the print dialog on it. Where a browser will not
// print a PDF inside a frame, the PDF opens in a new tab instead - said in
// the result, so the page can tell the person to print from there.
//
// A frame that never says it loaded (a browser with no built-in PDF viewer)
// would leave the button spinning with nothing on screen; after `waitMs` the
// PDF opens in a tab instead, so Print always ends somewhere visible.
export function printPdfBlob(blob, { doc = document, win = window, waitMs = 6000 } = {}) {
  return new Promise((resolve) => {
    let done = false;
    const finish = (how) => { if (!done) { done = true; resolve(how); } };
    const href = win.URL.createObjectURL(blob);
    const frame = doc.createElement("iframe");
    frame.setAttribute("aria-hidden", "true");
    frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
    // Kept until the page leaves or the next print: removing the frame while
    // the dialog is open cancels the print in Chrome.
    const old = doc.getElementById("shop-drawings-print-frame");
    if (old) old.remove();
    frame.id = "shop-drawings-print-frame";
    const fallback = () => {
      if (done) return;
      const w = win.open(href, "_blank");
      finish(w ? "tab" : "blocked");
    };
    const timer = setTimeout(fallback, waitMs);
    frame.onload = () => {
      clearTimeout(timer);
      if (done) return;
      try {
        frame.contentWindow.focus();
        frame.contentWindow.print();
        finish("dialog");
      } catch (e) {
        fallback();
      }
    };
    frame.src = href;
    doc.body.appendChild(frame);
  });
}
